import { ReactComponent as ChevronRight } from 'assets/icons/icon-chevron-right.svg';

export default ChevronRight;
